/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomKPI from "../../../Core/Components/CustomKpi";
import { FinanceHoverIcon } from "../../../Common/Svgs/FinanceIcon";
import { PaymentKPIData, TOTAL_PAID_FILTER } from "./data";
import PaymentHeader from "./PaymentHeader";
import CustomTable from "../../../Core/Components/CustomTable";
import { updateRevenue } from "../../../Redux/Slices/revenue.slice";
import {
  getDriverPaymentList,
  getFarmerPaymentList,
  getPaymentKPI,
  getTotalPaymentPaidKPI,
} from "../../../Redux/APIs/revenueAPI";
import { PAYMENT_RECEIVER_TYPE } from "../data";
import useDebounce from "../../../Core/hooks/useDebounce";
// import KpiTimeFilter from "./KpiTimeFilter";
import useColumns from "./useColumns";
import ExportDrawer from "./Export/ExportDrawer";
import ToastMessageModal from "./ToastMessageModal";
import CustomPagination from "../../../Core/Components/CustomPagination";
import { DEFAULT_LIMIT } from "../../../Utils/constants";

const PaymentList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    paymentKPI,
    totalPaymentPaid,
    showToastMessage,
    farmerPaymentList,
    driverPaymentList,
    paymentListCurrentPage,
  } = useSelector((state) => state.revenue);

  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(DEFAULT_LIMIT);
  const [filters, setFilters] = useState({
    hub: [],
    userType: [],
    paymentStatus: [],
  });

  const [selectedView, setSelectedView] = useState(
    PAYMENT_RECEIVER_TYPE.FARMER,
  );

  const [kpiFilter, setKpiFilter] = useState({
    id: 1,
    value: "all time",
    custom: [],
  });

  const [exportDrawer, setExportDrawer] = useState(false);

  const columns = useColumns(selectedView);
  const debounceSearch = useDebounce(search, 500);

  const handleRowClick = (record) => {
    dispatch(
      updateRevenue({
        key: "selectedPayment",
        value: record,
      }),
    );

    navigate(
      `/revenue/payment-details/${record.entityType}/${record.entityId}`,
    );
  };

  // fetch the payment list on every page change and filter applied
  useEffect(() => {
    const filterObj = {
      offset: ((paymentListCurrentPage || 1) - 1) * pageSize,
      limit: pageSize,
    };

    if (debounceSearch) filterObj.searchQuery = debounceSearch;
    if (filters.hub.length) filterObj.hubIds = filters.hub;
    if (filters.paymentStatus.length)
      filterObj.paymentStatus = filters.paymentStatus;

    if (selectedView === PAYMENT_RECEIVER_TYPE.FARMER) {
      dispatch(getFarmerPaymentList(filterObj));
    } else {
      dispatch(getDriverPaymentList(filterObj));
    }
  }, [dispatch, paymentListCurrentPage, pageSize, filters, debounceSearch, selectedView]);

  // get payment kpi
  useEffect(() => {
    dispatch(getPaymentKPI());
  }, []);

  useEffect(() => {
    const filterObj = {
      type: kpiFilter.id,
      custom: kpiFilter.custom,
    };

    // if the filter is custom -> only make the API call if both the custom dates are selected
    if (
      kpiFilter.id === TOTAL_PAID_FILTER.CUSTOM &&
      kpiFilter.custom.length > 1
    ) {
      dispatch(getTotalPaymentPaidKPI(filterObj));
    }

    // if the filter is not custom then make the API call
    if (kpiFilter.id !== TOTAL_PAID_FILTER.CUSTOM) {
      dispatch(getTotalPaymentPaidKPI(filterObj));
    }
  }, [dispatch, kpiFilter]);

  // clear the toast message
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (showToastMessage?.visible)
        dispatch(
          updateRevenue({
            key: "showToastMessage",
            value: {
              visible: false,
              data: {},
            },
          }),
        );
    }, 5000);

    return () => clearTimeout(timeout);
  }, [dispatch, showToastMessage]);

  return (
    <div>
      <div className="w-full flex items-center gap-x-6 p-6">
        {PaymentKPIData(paymentKPI, totalPaymentPaid).map((item) => (
          <CustomKPI
            key={item.title}
            title={item.title}
            count={item.count}
            countColor={item.countColor}
            background={item.background}
            image={item.icon}
            unit="KSH"
            // renderFilter={
            //   item.id === 3 && (
            //     <KpiTimeFilter
            //       currentFilter={kpiFilter}
            //       setCurrentFilter={setKpiFilter}
            //     />
            //   )
            // }
          />
        ))}
      </div>

      <div>
        <PaymentHeader
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          selectedView={selectedView}
          setSelectedView={setSelectedView}
          setKpiFilter={setKpiFilter}
          onExportClick={() => setExportDrawer(true)}
        />

        <div
          className={`h-[calc(100vh-72px-71px-162px-69px-32px)] ${
            selectedView === PAYMENT_RECEIVER_TYPE.FARMER
              ? farmerPaymentList.result.length && "overflow-y-scroll"
              : driverPaymentList.result.length && "overflow-y-scroll"
          }`}
        >
          <CustomTable
            disableScroll
            columns={columns}
            data={
              selectedView === PAYMENT_RECEIVER_TYPE.FARMER
                ? farmerPaymentList.result
                : driverPaymentList.result
            }
            onRowClick={handleRowClick}
            emptyState={
              <FinanceHoverIcon size={16} className="text-dark-grey-text" />
            }
            rowClassName="group cursor-pointer"
            pagination={{
              pageSize,
              total:
                selectedView === PAYMENT_RECEIVER_TYPE.FARMER
                  ? farmerPaymentList.totalRecords
                  : driverPaymentList.totalRecords,
              showSizeChanger: true,
              onShowSizeChange: (current, size) => {
                setPageSize(size);
                dispatch(
                  updateRevenue({ key: "paymentListCurrentPage", value: 1 }),
                );
              },
              onChange: (page, size) => {
                if (size && size !== pageSize) {
                  setPageSize(size);
                  dispatch(
                    updateRevenue({ key: "paymentListCurrentPage", value: 1 }),
                  );
                } else {
                  dispatch(
                    updateRevenue({ key: "paymentListCurrentPage", value: page }),
                  );
                }
              },
              current: paymentListCurrentPage,
              itemRender: (current, type, originalElement) => {
                const totalRecords =
                  selectedView === PAYMENT_RECEIVER_TYPE.FARMER
                    ? farmerPaymentList?.totalRecords
                    : driverPaymentList?.totalRecords;

                return (
                  <CustomPagination
                    type={type}
                    current={current}
                    originalElement={originalElement}
                    totalRecords={Number(totalRecords || 0)}
                  />
                );
              },
              // itemRender: (current, type, originalElement) => {
              //   const lastPage =
              //     selectedView === PAYMENT_RECEIVER_TYPE.FARMER
              //       ? farmerPaymentList.totalRecords
              //       : driverPaymentList.totalRecords / current;

              //   if (type === "prev" && current === 0) {
              //     return (
              //       <button
              //         type="button"
              //         className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
              //         style={{
              //           pointerEvents: "none",
              //         }}
              //       >
              //         <ChevronIcon className="stroke-dark-gray" />
              //       </button>
              //     );
              //   }

              //   if (type === "prev" && current > 0) {
              //     return (
              //       <button
              //         type="button"
              //         className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
              //       >
              //         <ChevronIcon className="stroke-dark-gray" />
              //       </button>
              //     );
              //   }

              //   if (type === "next" && lastPage <= 10) {
              //     return (
              //       <button
              //         type="button"
              //         className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
              //         style={{ pointerEvents: "none" }}
              //       >
              //         <ChevronIcon className="stroke-dark-gray" />
              //       </button>
              //     );
              //   }

              //   if (type === "next") {
              //     return (
              //       <button
              //         type="button"
              //         className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
              //       >
              //         <ChevronIcon className="stroke-dark-gray" />
              //       </button>
              //     );
              //   }

              //   return originalElement;
              // },
            }}
          />
        </div>

        <ExportDrawer
          visible={exportDrawer}
          onCancel={() => setExportDrawer(false)}
          selectedView={selectedView}
        />

        <ToastMessageModal
          visible={showToastMessage?.visible}
          onCancel={() =>
            dispatch(
              updateRevenue({
                key: "showToastMessage",
                value: {
                  visible: false,
                  data: {},
                },
              }),
            )
          }
          title={showToastMessage?.data?.title}
          description={showToastMessage?.data?.description}
          type={showToastMessage?.data?.type || "success"}
        />
      </div>
    </div>
  );
};

export default PaymentList;
